import { Toast, type ToastManagerAddOptions } from '@base-ui/react';

import type { statusColorThemes } from '~/styles/themes.css';

export type ToastObjectOverrides = {
  description: string;
  title?: string;
  type: keyof typeof statusColorThemes;
};

export const toastManager = Toast.createToastManager();

export const toast = {
  success: (options) => toastManager.add({ ...options, type: 'success' }),
  danger: (options) => toastManager.add({ ...options, type: 'danger' }),
  neutral: (options) => toastManager.add({ ...options, type: 'neutral' }),
  discovery: (options) => toastManager.add({ ...options, type: 'discovery' }),
  info: (options) => toastManager.add({ ...options, type: 'info' }),
  warning: (options) => toastManager.add({ ...options, type: 'warning' }),
} satisfies Record<keyof typeof statusColorThemes, (options: Omit<ToastManagerAddOptions<never> & ToastObjectOverrides, 'type'>) => string>;
